export class Log {
  exception: string;
 
 
 
}
